import { Row } from 'antd';
import { useState } from 'react';
import { MdOutlineEdit } from 'react-icons/md';
import { useSelector } from 'react-redux';
import useIsTeamMember from '../../../../hooks/useIsTeamMember';
import { RootState } from '../../../../store/rootReducer';
import InfoView from '../../../common/InfoView';
import { KYCDoc } from '../../../login/redux/types';
import { InvestorStatus } from '../../../login/utils/Status';
import OnboardingCard from '../../onboarding/components/common/Card';
import OnboardingRightContainer from '../../onboarding/components/common/Container';
import InstitutionalKYC from '../../onboarding/components/kyc/Manual/InstitutionalKYC';
import { DocReadView, KYCInfo, Review } from './DefaultKYC';

const InstitutionalKYCSetting = () => {
    const kycInfo = useSelector((state: RootState) => state.user.investor?.kyc);

    return (
        <div>
            <KYCInfo />
            <Review />
            {(!kycInfo || !kycInfo.info || !kycInfo.info.address || !kycInfo.info.identity?.identityNumber) && (
                <OnboardingRightContainer>
                    <InstitutionalKYC isSetting={true} />
                </OnboardingRightContainer>
            )}
            {kycInfo && kycInfo.info && kycInfo.info.address && kycInfo.info.identity?.identityNumber && (
                <KYCReadView />
            )}
        </div>
    );
};
export default InstitutionalKYCSetting;

const KYCReadView = () => {
    const isTeamMember: boolean = useIsTeamMember();
    const kycInfo = useSelector((state: RootState) => state.user.investor?.kyc?.info);
    const kycDocs = useSelector((state: RootState) => state.user.investor?.kyc?.docs);
    const investorStatus = useSelector((state: RootState) => state.user.investor?.status?.kyc);
    const disabled =
        investorStatus !== InvestorStatus.PendingKYCSubmission &&
        investorStatus !== InvestorStatus.PendingKYCAdditionalDetails;

    const [isEdit, setEdit] = useState(false);

    let certDocs: KYCDoc[] = [],
        constitutionDocs: KYCDoc[] = [],
        directorsDocs: KYCDoc[] = [],
        shareholdersDocs: KYCDoc[] = [],
        financialDocs: KYCDoc[] = [],
        identityDocs: KYCDoc[] = [],
        addressDocs: KYCDoc[] = [];

    if (kycDocs && kycDocs.length > 0) {
        certDocs = kycDocs.filter((k) => k.type === 'Certificate of Incorporation');
        constitutionDocs = kycDocs.filter((k) => k.type === 'Constitution');
        directorsDocs = kycDocs.filter((k) => k.type === 'Register of Directors');
        shareholdersDocs = kycDocs.filter((k) => k.type === 'Register of Shareholders');
        financialDocs = kycDocs.filter((k) => k.type === 'Financial Statement');
        identityDocs = kycDocs.filter((k) => k.type === 'Identity Proof');
        addressDocs = kycDocs.filter((k) => k.type === 'Address Proof');
    }

    const keyValues = [
        {
            name: 'Name',
            value: kycInfo && kycInfo.legalName,
        },
        {
            name: 'Company Registration No',
            value: kycInfo && kycInfo.identity?.identityNumber,
        },
    ];
    const contactValue = [
        {
            name: 'Address 1',
            value: kycInfo && kycInfo.address && kycInfo.address.address1,
        },
        {
            name: 'Address 2',
            value: kycInfo && kycInfo.address && kycInfo.address.address2,
        },
        {
            name: 'Postal Code',
            value: kycInfo && kycInfo.address && kycInfo.address.postalCode,
        },
        {
            name: 'Country',
            value: kycInfo && kycInfo.address && kycInfo.address.country,
        },
    ];

    if (isEdit) {
        return (
            <OnboardingRightContainer>
                <InstitutionalKYC isSetting={true} onClickCancel={() => setEdit(false)} />
            </OnboardingRightContainer>
        );
    }

    return (
        <OnboardingCard>
            <div className="cursor-default w-full flex justify-between">
                <div className={`${disabled ? 'w-full' : 'w-11/12'}`}>
                    <p className="page_title_onboarding mb-4">Company Information</p>
                    <Row gutter={[16, 16]}>
                        {keyValues.map((kv, index) => (
                            <InfoView name={kv.name} value={kv.value} index={index} key={`${kv.name}_${index}`} />
                        ))}
                    </Row>
                    <p className="page_title_onboarding my-4 pt-8">Address Information</p>
                    <Row gutter={[16, 16]}>
                        {contactValue.map((kv, index) => (
                            <InfoView name={kv.name} value={kv.value} index={index} key={`${kv.name}_${index}`} />
                        ))}
                    </Row>
                    <p className="page_title_onboarding my-4 pt-8">KYC Documents</p>
                    <Row gutter={[16, 32]}>
                        <DocReadView
                            title="Certificate of Incorporation / Business Registration (Certified True Copy)"
                            list={certDocs}
                        />
                        <DocReadView
                            title="Constitution / Memorandum and Articles of Association (Certified True Copy)"
                            list={constitutionDocs}
                        />
                        <DocReadView title="Register of Directors" list={directorsDocs} />
                        <DocReadView title="Register of Shareholders" list={shareholdersDocs} />
                        <DocReadView title="Audited Financial Statements" list={financialDocs} />
                        <DocReadView
                            title="NRIC/Passport for all Directors, Authorised Signatories and Ultimate Beneficial Owners (Certified True Copy)"
                            list={identityDocs}
                        />
                        <DocReadView
                            title="Proof of address for all Directors, Authorised Signatories and Ultimate Beneficial Owners"
                            list={addressDocs}
                        />
                    </Row>
                </div>
                {!disabled && !isTeamMember && (
                    <div
                        className="w-9 h-9 md:w-10 md:h-10 rounded-full  cursor-pointer flex justify-center items-center"
                        style={{ backgroundColor: '#F5F6FF' }}
                        onClick={() => setEdit(true)}
                    >
                        <MdOutlineEdit className="text-xl md:text-2xl" color="#1B3E8C" />
                    </div>
                )}
            </div>
        </OnboardingCard>
    );
};
